import { render, staticRenderFns } from "./Page7.vue?vue&type=template&id=604b4008&scoped=true&"
import script from "./Page7.vue?vue&type=script&lang=ts&"
export * from "./Page7.vue?vue&type=script&lang=ts&"
import style0 from "./Page7.vue?vue&type=style&index=0&id=604b4008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b4008",
  null
  
)

export default component.exports